import { useAtom } from 'jotai'
import React from 'react'

import { brandAccountIdLastSurveyGroupIdMapAtom } from '~/atoms'
import { useRouteParams } from '~/hooks/useRouteParams'
import { exists } from '~/utils'

/**
 * 現在のサーベイグループIDを管理するカスタムフックです。
 *
 * @returns 現在のサーベイグループIDと、現在のサーベイグループIDを設定する関数のタプル。
 */
export const useCurrentSurveyGroupIdState = () => {
  const { brandAccountId, surveyId } = useRouteParams()

  const [
    brandAccountIdLastSurveyGroupIdMap,
    setBrandAccountIdLastSurveyGroupIdMap,
  ] = useAtom(brandAccountIdLastSurveyGroupIdMapAtom)

  const currentSurveyGroupId = React.useMemo(() => {
    if (exists(surveyId) || !exists(brandAccountId)) {
      return undefined
    }

    return brandAccountIdLastSurveyGroupIdMap?.[brandAccountId]
  }, [brandAccountId, brandAccountIdLastSurveyGroupIdMap, surveyId])

  const setCurrentSurveyGroupId = React.useCallback(
    (currentSurveyGroupId: string) => {
      if (exists(brandAccountId)) {
        setBrandAccountIdLastSurveyGroupIdMap(
          (brandAccountIdLastSurveyGroupIdMap) =>
            exists(brandAccountIdLastSurveyGroupIdMap)
              ? {
                  ...brandAccountIdLastSurveyGroupIdMap,
                  [brandAccountId]: currentSurveyGroupId,
                }
              : {
                  [brandAccountId]: currentSurveyGroupId,
                },
        )
      }
    },
    [brandAccountId, setBrandAccountIdLastSurveyGroupIdMap],
  )

  return React.useMemo(
    () => [currentSurveyGroupId, setCurrentSurveyGroupId] as const,
    [currentSurveyGroupId, setCurrentSurveyGroupId],
  )
}
